import { $authHost, $host } from ".";
import type {
  EnrollCourseResponse,
  GetClientCoursesResponse,
  GetCourseClassesResponse,
  GetCourseDescriptionResponse,
  GetCoursesResponse,
} from "@/@types/courses.types";

export async function getCourses(clubId: string, userToken?: string) {
  return $host.get<GetCoursesResponse>("/courses/", {
    params: { club_id: clubId },
    ...(userToken && { headers: { usertoken: userToken } }),
  });
}

export async function getCourseDescription(courseId: string, userToken?: string) {
  return $host.get<GetCourseDescriptionResponse>("/course_description/", {
    params: { course_id: courseId },
    ...(userToken && { headers: { usertoken: userToken } }),
  });
}

export async function getClientCourses(userToken: string) {
  return $authHost.get<GetClientCoursesResponse>("/client_courses/", {
    headers: { usertoken: userToken },
  });
}

export async function getClasses(
  clubId: string,
  startDate: string,
  endDate: string,
  userToken?: string
) {
  return $host.get<GetCourseClassesResponse>("/classes/", {
    params: { club_id: clubId, start_date: startDate, end_date: endDate },
    ...(userToken && { headers: { usertoken: userToken } }),
  });
}

export async function enrollInCourse(courseId: string, userToken: string) {
  return $authHost.post<EnrollCourseResponse>(
    "/client_to_course",
    { course_id: courseId },
    { headers: { usertoken: userToken } }
  );
}

export async function enrollInClass(
  appointmentId: string,
  ticketId: string | null,
  userToken: string
) {
  const body: Record<string, string> = { appointment_id: appointmentId };
  if (ticketId) body.ticket_id = ticketId;
  return $authHost.post<EnrollCourseResponse>("/client_to_class/", body, {
    headers: { usertoken: userToken },
  });
}

export async function cancelClassEnrollment(appointmentId: string, userToken: string) {
  return $authHost.delete<EnrollCourseResponse>("/client_from_class/", {
    params: { appointment_id: appointmentId },
    headers: { usertoken: userToken },
  });
}
